export default __webpack_public_path__ + "static/t-mark-cb5c41f7269067a093ca6920203de9ac.png";